import styled from "styled-components";

export const FreeToolBanner = styled.p`
  display: inline-block;
  color: white;
  background-color: ${({ theme }) => theme.colors.green};
  font-size: ${({ theme }) => theme.font.size.sm};
  padding: ${({ theme }) => theme.space.xs} ${({ theme }) => theme.space.sm};
  margin: ${({ theme }) => theme.space.sm} 0;
`;
